import React from 'react';

export default function Wallet() {
	return (
		<div className="main">
			<p style={{fontSize:"20px", color:"var(--text-color)"}}>WALLET</p>
		</div>
	);
}